import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import projectsData from './projects/data';
import ProjectCard from './projects/ProjectCard';   

const categories = [
  "All",
  "Artificial Intelligence",
  "Generative AI",
  "Computer Vision",
  "Machine Learning",
  "Web Development",
  "Miscellaneous"
];

const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const filteredProjects = selectedCategory === "All" 
    ? projectsData 
    : projectsData.filter(project => project.category === selectedCategory);

  return (
    <div id="projects" className="min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4
            bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 
            bg-clip-text text-transparent pb-2">
            Projects
          </h2>
          <p className="text-neutral-600 dark:text-neutral-400 text-lg max-w-2xl mx-auto">
            A showcase of projects in Artificial Intelligence, Machine Learning, Computer Vision, Generative AI, and Full-Stack Web Development.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2.5 rounded-full font-medium text-sm
                transition-all duration-300 transform hover:scale-105
                ${selectedCategory === category
                  ? 'bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white shadow-lg shadow-purple-500/30'
                  : 'bg-white dark:bg-neutral-900 text-neutral-700 dark:text-neutral-300 border border-neutral-200 dark:border-neutral-800 hover:border-purple-400 dark:hover:border-purple-600'
                }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {filteredProjects.map((project, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <ProjectCard 
                project={project} 
                isHovered={hoveredIndex === index} 
              />
            </div>
          ))}
        </div>

        {/* No Results Message */}
        {filteredProjects.length === 0 && (
          <div className="text-center py-12 col-span-1 md:col-span-2 lg:col-span-3">
            <Icon icon="mdi:folder-search-outline" className="w-16 h-16 mx-auto text-neutral-400 dark:text-neutral-600 mb-4" />
            <p className="text-neutral-600 dark:text-neutral-400">No projects found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;